// @flow
import React from "react";

const ReloadButton = () => {
    
    return (
        <span>
            <button className="btn ml-auto mr-3 align-self-center" onClick={() => window.location.reload()}><i className="fa fa-redo"/></button>
        </span>
    );
}

export default ReloadButton;